import { action } from 'satcheljs';
import { ActionSource } from 'owa-analytics-actions';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { addDatapointConfig } from 'owa-analytics-actions';

export const moveRowsToInboxPlusPivot = action(
    'MOVE_ROWS_TO_INBOX_PLUS_PIVOT',
    (
        rowKeys: string[],
        sourcePivot: InboxClassificationFilter,
        destinationPivot: InboxClassificationFilter,
        tableViewId: string,
        actionSource: ActionSource
    ) =>
        addDatapointConfig(
            {
                name: 'TnS_MoveRowsToInboxPlusPivot',
                options: { isCore: true },
                customData: [sourcePivot, destinationPivot, actionSource],
            },
            {
                rowKeys,
                sourcePivot,
                destinationPivot,
                tableViewId,
            }
        )
);
